import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

const ProgressNode = props => {
    const isPassed = props.progressState <= props.currentState;
    const backgroundUrl = isPassed ? props.activeBackgroundUrl : props.inactiveBackgroundUrl;
    const backgroundStyle = {
        background: `url(${backgroundUrl})`,
        backgroundSize: '100% auto',
        backgroundRepeat: 'no-repeat',
        zIndex: 100 - props.progressState
    };
    const iconClasses = classNames('progress-node-icon', {active: isPassed});

    return (
        <li className="campaign-progress-list-item" style={backgroundStyle}>
            <div className="progress-node-body">
                <div className={iconClasses} />
                <div className="progress-node-subtitle">{props.subtitle}</div>
            </div>
        </li>
    );
};

ProgressNode.propTypes = {
    currentState: PropTypes.string.isRequired,
    progressState: PropTypes.number.isRequired,
    activeBackgroundUrl: PropTypes.string.isRequired,
    inactiveBackgroundUrl: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired
};

export default ProgressNode;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/progress_bar/progress_node.js